import type { MLTripSummary } from "@/features/towers/types";
import {
  type DeliveryBenchmarkLane,
  isArrivedBenchmarkEligibleStop,
} from "@/features/towers/utils/deliveryBenchmark";
import {
  getVisitStatusForStopBenchmark,
  type VisitStatus,
} from "@/features/towers/utils/visitStatus";

/** Fixed multiselect options for trip list delivery status filters. */
export const TRIP_VISIT_STATUS_FILTER_OPTIONS: readonly VisitStatus[] = [
  "LATE",
  "EARLY",
  "ON_TIME",
  "UNKNOWN",
];

export const DEFAULT_TRIP_VISIT_STATUS_FILTER_SELECTION: VisitStatus[] = [
  ...TRIP_VISIT_STATUS_FILTER_OPTIONS,
];

export function isTripCompletedStatusFilterAllSelected(
  selectedStatuses: readonly VisitStatus[],
): boolean {
  return TRIP_VISIT_STATUS_FILTER_OPTIONS.every((status) =>
    selectedStatuses.includes(status),
  );
}

export function tripMatchesVisitStatusFilterSelection(
  selectedStatuses: readonly VisitStatus[],
  tripStatuses: readonly VisitStatus[],
): boolean {
  if (selectedStatuses.length === 0) {
    return false;
  }

  if (isTripCompletedStatusFilterAllSelected(selectedStatuses)) {
    return true;
  }

  if (tripStatuses.length === 0) {
    return selectedStatuses.includes("UNKNOWN");
  }

  return tripStatuses.some((status) => selectedStatuses.includes(status));
}

export function tripMatchesCompletedStatusFilter(
  trip: MLTripSummary,
  selectedStatuses: readonly VisitStatus[],
  lane: DeliveryBenchmarkLane,
): boolean {
  const statuses: VisitStatus[] = [];
  for (const stop of trip.stopSummaries) {
    if (!isArrivedBenchmarkEligibleStop(stop)) {
      continue;
    }
    statuses.push(getVisitStatusForStopBenchmark(stop, lane) ?? "UNKNOWN");
  }

  return tripMatchesVisitStatusFilterSelection(selectedStatuses, statuses);
}
